/**
 * Contratti delle viste di piattaforma, riservate al Super Admin (V54-V56).
 *
 * La creazione di una societa porta con se l'invito del suo Admin Squadra:
 * una societa senza chi la amministra non ha nessuno che possa entrarci.
 */

import { z } from 'zod';
import { idSchema, invitaAccountSchema } from './contratti.js';

const persona = {
  email: invitaAccountSchema.shape.email,
  nome: invitaAccountSchema.shape.nome,
  cognome: invitaAccountSchema.shape.cognome,
};

/** Nuova societa (V54) e l'indirizzo del suo Admin Squadra. */
export const creaSocietaSchema = z.object({
  societa: z.string().trim().min(1, 'Il nome è obbligatorio.').max(80, 'Massimo 80 caratteri.'),
  ...persona,
});

export type DatiNuovaSocieta = z.infer<typeof creaSocietaSchema>;

/** Tetto di sicurezza: un limite e una deroga, non un modo di toglierlo. */
export const MASSIMO_LIMITE = 100_000;

const limite = (nome: string) =>
  z.coerce
    .number({ invalid_type_error: `${nome}: serve un numero.` })
    .int(`${nome}: serve un numero intero.`)
    .min(1, `${nome}: almeno 1.`)
    .max(MASSIMO_LIMITE, `${nome}: al massimo ${MASSIMO_LIMITE.toLocaleString('it-IT')}.`);

/** Deroga individuale ai limiti (V55). */
export const limitiSocietaSchema = z.object({
  maxSquadreStagione: limite('Squadre per stagione'),
  maxGiocatori: limite('Anagrafiche'),
  maxAccount: limite('Account'),
  maxMessaggiAssistente: limite("Domande all'assistente al mese"),
});

export type LimitiSocieta = z.infer<typeof limitiSocietaSchema>;

/** Disattivazione e riattivazione della societa (V54, V55). */
export const statoSocietaSchema = z.object({ attiva: z.boolean() });

/**
 * Nuovo Admin Squadra (V55): un account attivo della societa, oppure un
 * indirizzo nuovo da invitare.
 */
export const nominaAdminSchema = z.discriminatedUnion('modo', [
  z.object({ modo: z.literal('account'), accountId: idSchema }),
  z.object({ modo: z.literal('invito'), ...persona }),
]);

export type NominaAdmin = z.infer<typeof nominaAdminSchema>;

/** Minimo di caratteri per la ricerca di account (V56). */
export const MINIMO_RICERCA = 3;

export const ricercaAccountSchema = z.object({
  q: z
    .string()
    .trim()
    .min(MINIMO_RICERCA, `Scrivi almeno ${MINIMO_RICERCA} caratteri dell'email.`)
    .max(254, 'Massimo 254 caratteri.'),
});
